// Mock data for Clara Boxing Academy

export const mockEvents = [
  {
    id: 1,
    title: "Youth Boxing Class",
    date: new Date(2025, 0, 10), // January 10, 2025
    time: "5:00 PM - 6:00 PM",
    location: "Main Training Area",
    spots: 8,
    maxSpots: 12,
    type: "class",
    description: "Beginner-friendly boxing class for ages 8-17"
  },
  {
    id: 2,
    title: "Adult Fitness Boxing",
    date: new Date(2025, 0, 10), // January 10, 2025
    time: "7:00 PM - 8:00 PM",
    location: "Main Training Area",
    spots: 6,
    maxSpots: 10,
    type: "class",
    description: "High-intensity boxing workout for adults"
  },
  {
    id: 3,
    title: "Sparring Session",
    date: new Date(2025, 0, 12), // January 12, 2025
    time: "10:00 AM - 12:00 PM",
    location: "Boxing Ring",
    spots: 4,
    maxSpots: 8,
    type: "sparring",
    description: "Controlled sparring for intermediate/advanced boxers"
  },
  {
    id: 4,
    title: "Personal Training Available",
    date: new Date(2025, 0, 15), // January 15, 2025
    time: "2:00 PM - 3:00 PM",
    location: "Private Training Area",
    spots: 1,
    maxSpots: 1,
    type: "personal",
    description: "One-on-one training session with Coach Rene"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    age: 16,
    role: "Youth Member",
    text: "Coach Rene has completely transformed my confidence. I started as a shy beginner and now I'm preparing for my first amateur competition!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Mike Rodriguez",
    age: 28,
    role: "Adult Member",
    text: "The family atmosphere here is incredible. Michelle and Rene make everyone feel welcome, from kids to pros. Best gym I've ever trained at.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Lisa Chen",
    age: 34,
    role: "Parent & Member",
    text: "My daughter and I both train here. The coaches are patient with beginners but push you to reach your potential. It's truly a family gym.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b123?w=150&h=150&fit=crop&crop=face"
  }
];

export const mockGalleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    caption: "Training Session",
    category: "training"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=400&h=300&fit=crop",
    caption: "Boxing Equipment",
    category: "equipment"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1552072092-7f9b8d63efcb?w=400&h=300&fit=crop",
    caption: "Boxing Ring",
    category: "facility"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    caption: "Youth Training",
    category: "youth"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1570456665713-8d76b7e8ba5d?w=400&h=300&fit=crop",
    caption: "Professional Training",
    category: "training"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1591117207239-788bf8de6c3b?w=400&h=300&fit=crop",
    caption: "Competition Prep",
    category: "competition"
  }
];

export const mockFAQs = [
  {
    id: 1,
    question: "Do I need experience?",
    answer: "Nope! We welcome all levels—from total beginners to experienced fighters. Our coaches will work with you at your pace."
  },
  {
    id: 2,
    question: "What do I need to bring?",
    answer: "Comfortable clothes, water, and a positive attitude. Gloves and gear can be borrowed or purchased at the gym."
  },
  {
    id: 3,
    question: "Is it safe for kids?",
    answer: "Yes, our youth program is structured, respectful, and taught by experienced coaches. Safety is our top priority."
  },
  {
    id: 4,
    question: "Do you offer private sessions?",
    answer: "Yes, we offer personal training sessions. Ask us for pricing and scheduling details."
  },
  {
    id: 5,
    question: "What ages do you accept?",
    answer: "We welcome all ages! Our youth program starts from age 8, and we have no upper age limit for adults."
  },
  {
    id: 6,
    question: "Do I need to sign a contract?",
    answer: "No contracts required! We operate on a month-to-month basis to give you flexibility."
  }
];

export const mockContactSubmissions = [];

export const mockBookingRequests = [];



export const galleryData = [
  // ✅ LATEST MEDIA — added most recently, shown first
  {
    id: 33,
    type: "image",
    url: "/images/updated1.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 34,
    type: "video",
    url: "/images/updated-video_h264.mp4",
    caption: "",
    category: "training",
  },
  {
    id: 35,
    type: "image",
    url: "/images/updated2.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 36,
    type: "image",
    url: "/images/updated3.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 37,
    type: "image",
    url: "/images/updated4.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 38,
    type: "image",
    url: "/images/updated5.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 39,
    type: "image",
    url: "/images/updated6.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 40,
    type: "image",
    url: "/images/updated7.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 41,
    type: "image",
    url: "/images/updated8.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 42,
    type: "image",
    url: "/images/updated9.jpeg",
    caption: "",
    category: "training",
  },

  // NEW FIRST ITEMS (old IDs 38, 39, 40)
  {
    id: 1,
    type: "image",
    url: "/images/new.jpg",
    caption: "",
    category: "training",
  },
  {
    id: 2,
    type: "image",
    url: "/images/new2.jpg",
    caption: "",
    category: "training",
  },
  {
    id: 3,
    type: "image",
    url: "/images/new3.jpg",
    caption: "",
    category: "training",
  },

  // REST — SAME ORDER AS BEFORE, BUT IDS CONTINUE FROM 4
  {
    id: 4,
    type: "image",
    url: "/images/training.jpeg",
    category: "training",
  },
  {
    id: 5,
    type: "image",
    url: "/images/training2.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 6,
    type: "image",
    url: "/images/training11.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 7,
    type: "video",
    url: "/images/trainvideo_h264.mp4",
    caption: "",
    category: "training",
  },
  {
    id: 8,
    type: "video",
    url: "/images/trainvideo2_h264.mp4",
    caption: "",
    category: "training",
  },
  {
    id: 9,
    type: "video",
    url: "/images/trainvideo3_h264.mp4",
    caption: "",
    category: "training",
  },
  {
    id: 10,
    type: "video",
    url: "/images/trainvideo4_h264.mp4",
    caption: "",
    category: "training",
  },
  {
    id: 11,
    type: "video",
    url: "/images/trainvideo5_h264.mp4",
    caption: "",
    category: "training",
  },
  {
    id: 12,
    type: "video",
    url: "/images/trainvideo6_h264.mp4",
    caption: "",
    category: "training",
  },
  {
    id: 13,
    type: "image",
    url: "/images/equipment2.jpeg",
    caption: "Facility Gear",
    category: "facility",
  },
  {
    id: 14,
    type: "image",
    url: "/images/ringempty.jpeg",
    caption: "Ring",
    category: "facility",
  },
  {
    id: 15,
    type: "image",
    url: "/images/logoimage.jpeg",
    caption: "Facility Gear",
    category: "facility",
  },
  {
    id: 16,
    type: "image",
    url: "/images/Youth1.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 17,
    type: "image",
    url: "/images/Youth2.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 18,
    type: "image",
    url: "/images/Youth3.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 19,
    type: "image",
    url: "/images/Youth4.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 20,
    type: "image",
    url: "/images/youth6.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 21,
    type: "image",
    url: "/images/youth7.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 22,
    type: "image",
    url: "/images/youth8.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 23,
    type: "image",
    url: "/images/youth9.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 24,
    type: "image",
    url: "/images/youth10.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 25,
    type: "image",
    url: "/images/youth11.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 26,
    type: "image",
    url: "/images/youth12.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 27,
    type: "image",
    url: "/images/youthedit2.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 28,
    type: "image",
    url: "/images/youthedit3.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 29,
    type: "image",
    url: "/images/youthedit4.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 30,
    type: "image",
    url: "/images/youthedit5.jpeg",
    caption: "",
    category: "training",
  },
  {
    id: 31,
    type: "image",
    url: "/images/facility1.jpeg",
    caption: "",
    category: "facility",
  },
  {
    id: 32,
    type: "image",
    url: "/images/facility2.jpeg",
    caption: "",
    category: "facility",
  },
];
